import "@iluvatar/composer/styles.css";
// routes
import { Router, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ConfirmationModal } from "./components/ConfirmationModal";
import { LoadingScreen } from "./components/LoadingIndicator";
import { queryClient } from "./contexts/react-query/query-client";
import { ReactQueryProvider } from "./contexts/react-query/react-query.context";
import AllContexts from "./contexts/root";
import DefaultLayout from "./layout/default-page";
import { Route as NotFoundRoute } from "./pages/-notFound";
import { routeTree } from "./routeTree.gen";

import "@iluvatar/ui-kit/styles.css";
import "./main.css";

// Load telemetry independently of rendering and authentication.
if (import.meta.env.REACT_APP_MEASUREMENT_ID) {
  window.addEventListener(
    "load",
    () => {
      void import("./services/firebase.service").catch(() => {});
    },
    { once: true },
  );
}

// Set up a Router instance
const router = new Router({
  routeTree,
  context: {
    queryClient: queryClient,
  },
  defaultPreload: "intent",
  defaultPendingMs: 400,
  defaultPendingMinMs: 300,
  defaultPreloadStaleTime: 0,
  notFoundRoute: NotFoundRoute,
  defaultPendingComponent: () => (
    <DefaultLayout>
      <LoadingScreen />
    </DefaultLayout>
  ),

  // defaultErrorComponent: ({ error }: any) => <ErrorComponent error={error} />,
});

// Register things for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
  <StrictMode>
    <ReactQueryProvider>
      <AllContexts>
        <RouterProvider router={router} />
        <ConfirmationModal />
      </AllContexts>
    </ReactQueryProvider>
  </StrictMode>,
);
